module.exports = __webpack_public_path__ + "static/media/ic-cart.4ab9aaad.svg";